module.exports = __webpack_public_path__ + "img/Group 28816.6393b7fb.svg";